import {
  alert_styles_default
} from "./chunk.MS32LDLV.js";
import {
  SlAlert
} from "./chunk.BBHA2P2S.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  i,
  n
} from "./chunk.D5EJUUKV.js";
import {
  $,
  w
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/alert/alert.ts
import { t } from "i18next";
var FadvAlert = class extends SlAlert {
  async toast() {
  }
  renderCloseButton() {
    if (!this.closable)
      return w;
    return $`<span class="alert__close"><sl-icon-button part="close-button" exportparts="base:close-button__base" name="x" library="system" @click=${this.handleCloseClick} label=${t("components:common.close")} ></sl-icon-button></span>`;
  }
  render() {
    return $`<div part="base" class=${o({
      alert: true,
      "alert--open": this.open,
      "alert--closable": this.closable,
      "alert--primary": this.variant === "primary",
      "alert--secondary": this.variant === "secondary",
      "alert--tertiary": this.variant === "tertiary",
      "alert--success": this.variant === "success",
      "alert--neutral": this.variant === "neutral",
      "alert--warning": this.variant === "warning",
      "alert--danger": this.variant === "danger",
      "alert--has-icon": this["hasSlotController"].test("icon")
    })} role="alert" aria-live="assertive" aria-atomic="true" aria-hidden=${this.open ? "false" : "true"} @mousemove=${this.handleMouseMove} ><div class="alert__indicator"></div><span part="icon" class="alert__icon"><slot name="icon"></slot></span><fadv-typography variant="gray" scale="950" type="label-medium" weight="500" part="message" class="alert__message"><slot></slot></fadv-typography>${this.renderCloseButton()}</div>`;
  }
};
FadvAlert.styles = alert_styles_default;
__decorateClass([
  i(".alert")
], FadvAlert.prototype, "alert", 2);
FadvAlert = __decorateClass([
  n("fadv-alert")
], FadvAlert);

export {
  FadvAlert
};
